module.exports = __webpack_public_path__ + "imgs/ww-gray-logo.4fafdad9fc9a93d78d44908e4f7135e3.png";